import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { Menu } from "@base-ui/react/menu";
//#region src/components/menu/menu.root.tsx
/**
* Menu presents actions and nested categories with keyboard navigation. Use a
* Combobox or Select when choosing a form value instead of invoking an action.
*/
var MenuRoot = (t0) => {
	const $ = c(10);
	let children;
	let onOpenChange;
	let rootProps;
	if ($[0] !== t0) {
		({children, onOpenChange, ...rootProps} = t0);
		$[0] = t0;
		$[1] = children;
		$[2] = onOpenChange;
		$[3] = rootProps;
	} else {
		children = $[1];
		onOpenChange = $[2];
		rootProps = $[3];
	}
	let t1;
	if ($[4] !== onOpenChange) {
		t1 = (open) => {
			onOpenChange?.(open);
		};
		$[4] = onOpenChange;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== children || $[7] !== rootProps || $[8] !== t1) {
		t2 = /* @__PURE__ */ jsx(Menu.Root, {
			...rootProps,
			highlightItemOnHover: false,
			onOpenChange: t1,
			children
		});
		$[6] = children;
		$[7] = rootProps;
		$[8] = t1;
		$[9] = t2;
	} else t2 = $[9];
	return t2;
};
//#endregion
export { MenuRoot };
